import { render, staticRenderFns } from "./SurveyDetails.vue?vue&type=template&id=b6ae3ad2&scoped=true"
import script from "./SurveyDetails.vue?vue&type=script&lang=js"
export * from "./SurveyDetails.vue?vue&type=script&lang=js"
import style0 from "./SurveyDetails.vue?vue&type=style&index=0&id=b6ae3ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ae3ad2",
  null
  
)

export default component.exports